import React, { useState, useEffect } from 'react';
import { Table, Button, Space, Input, Select, Toast } from '@douyinfe/semi-ui';
import request from '../../utils/request';
import styles from './index.module.scss';
import { useLocation } from 'react-router-dom';
import { formatBytes } from '../../utils/clipboard';

const AccountAssets = (props) => {
    const location = useLocation && useLocation();
    // 获取 typ 参数（优先 props，其次 URL）
    const getTypFromUrl = () => {
        if (!location || !location.search) return '';
        const params = new URLSearchParams(location.search);
        return params.get('typ') || '';
    };
    const initialTyp = props.typ || getTypFromUrl();
    const [loading, setLoading] = useState(false);
    const [dataSource, setDataSource] = useState([]);
    const [pagination, setPagination] = useState({ currentPage: 1, pageSize: 10, total: 0 });
    const [typeList, setTypeList] = useState([]);
    const [type, setType] = useState(initialTyp);
    const [searchKey, setSearchKey] = useState('');
    const typLocked = !!initialTyp;

    // 获取类型列表
    const fetchTypeList = async () => {
        try {
            const res = await request.get('/go/sp/sp/list_service_provider_limit_typ/');
            if (res.errno === 0) {
                setTypeList(res.list || []);
            } else {
                Toast.error(res.errstr || '获取类型失败');
            }
        } catch (e) {
            Toast.error('获取类型失败');
        }
    };

    // 获取流水列表
    const fetchList = async (page = 1, limit = 10) => {
        setLoading(true);
        try {
            const res = await request.get('/go/sp/sp/list_service_provider_limit_record/', {
                params: {
                    page: page - 1,
                    limit,
                    typ: type || initialTyp || undefined,
                    key: searchKey || undefined
                }
            });
            if (res.errno === 0) {
                setDataSource(res.list || []);
                setPagination(prev => ({ ...prev, currentPage: page, total: res.total_cnt }));
            } else {
                Toast.error(res.errstr || '获取列表失败');
            }
        } catch (e) {
            Toast.error('获取列表失败');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchTypeList();
        fetchList();
        // eslint-disable-next-line
    }, []);

    const handleSearch = () => {
        fetchList(1, pagination.pageSize);
    };

    // 字节格式化函数
    const columns = [
        {
            title: '类型', dataIndex: 'typ', width: 100, render: (text) => {
                const item = typeList.find(i => i.uid == text);
                return item ? item.name : text;
            }
        },
        {
            title: '变动',
            dataIndex: 't',
            width: 100,
            render: (text, record) => {
                const value = Number(text);
                const style = { color: value > 0 ? 'green' : value < 0 ? 'red' : undefined };
                const display = record.typ == 4 ? formatBytes(text) : text;
                return <span style={style}>{display}</span>;
            }
        },
        {
            title: '剩余',
            dataIndex: 't_remain',
            width: 100,
            render: (text, record) => (
                record.typ == 4 ? formatBytes(text) : text
            )
        },
        { title: '备注', dataIndex: 'info', width: 200 },
        { title: '关联ID', dataIndex: 'third_id', width: 120 },
        {
            title: '创建时间', dataIndex: 'create_time', width: 180, render: (text) => {
                if (!text || text === '0') return '-';
                const date = new Date(parseInt(text));
                return date.toLocaleString();
            }
        },
    ];

    return (
        <div className={styles.accountAssetsContainer}>
            <div className={styles.header}>
                <Space>
                    <Select
                        style={{ width: 160 }}
                        placeholder="全部类型"
                        value={type}
                        onChange={v => setType(v)}
                        onDropdownVisibleChange={fetchTypeList}
                        allowClear
                        disabled={typLocked}
                    >
                        {typeList.map(item => (
                            <Select.Option key={item.uid} value={item.uid}>{item.name}</Select.Option>
                        ))}
                    </Select>
                    <Input
                        placeholder="搜索关键词"
                        value={searchKey}
                        onChange={setSearchKey}
                        style={{ width: 200 }}
                        showClear
                    />
                    <Button type="primary" onClick={handleSearch} loading={loading}>搜索</Button>
                </Space>
            </div>
            <Table
                loading={loading}
                columns={columns}
                dataSource={dataSource}
                pagination={{
                    currentPage: pagination.currentPage,
                    pageSize: pagination.pageSize,
                    total: pagination.total,
                    onPageChange: (page) => fetchList(page, pagination.pageSize),
                    onPageSizeChange: (size) => fetchList(1, size)
                }}
                rowKey="uid"
                scroll={{ x: 1000 }}
            />
        </div>
    );
};

export default AccountAssets; 